import React, { useCallback, useEffect, useRef, useState } from "react";
import ListaVerificacionService from "../../services/listaVerificacionService";
import EquipoService from "../../services/ListaVerificacion/EquipoService";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
interface IRequestCombo {
  modeloId: string | null;
  search: string;
}
const initialRequestCombo: IRequestCombo = {
  modeloId: null,
  search: "",
};

export const useComboEquipos = () => {
  
  const controllerRef = useRef<AbortController>(new AbortController());

  const [filter, setFilter] = useState<IRequestCombo>(initialRequestCombo);
  const [dataCombo, setDataCombo] = useState<IComboBoxOption[]>([]);

  const comboBoxRefEquipoModelo = useRef<IComboBox>(null);
  const _openOptionEquipo = useCallback(() => {
    comboBoxRefEquipoModelo.current?.focus(true);
  }, []);
  const onClickCamboEquipo = () => {
    comboBoxRefEquipoModelo.current?.focus(true);
  };
  const _onkeyUpSearchEquipo = (event: React.KeyboardEvent<IComboBox>) => {
    if (event.code === "Escape") {
      comboBoxRefEquipoModelo.current?.focus(false);
      setFilter({ ...filter, search: "" });
    } else {
      _openOptionEquipo();
      let { value } = event?.target as HTMLInputElement;
      setFilter({ ...filter, search: value });
    }
  };
  const postCombomEquiposPorModelo = () => {
    controllerRef.current.abort();
    const newController = new AbortController();
    controllerRef.current = newController;
    EquipoService.PostListarComboEquipoPorModeloId(filter, newController).then((result) => {
      if (result.status === 200) {
        setDataCombo(result.data);
      }
    }).catch((error) => {
      console.error("Error fetching Combo Equipos:", error);
    });
  };

  const onChangeModelo = (e, o) => {
    if (o?.key) {
      setFilter({ ...filter, modeloId: o.key });
    }
  };

  const limpiarFilters = () => {
    setFilter(initialRequestCombo);
  };

  useEffect(() => {
    postCombomEquiposPorModelo();
  }, [filter]);

  return {
    comboBoxRefEquipoModelo,
    _onkeyUpSearchEquipo,
    dataCombo,
    onClickCamboEquipo,
    onChangeModelo,
    setFilter,
    limpiarFilters,
  };
};
